<template>
  <div class="totals-statistics flex-column mb-2">
    <div class="d-flex">
      <div class="d-flex p-0 align-items-start col-2">
        <span class="statistics-heading">
          Statistics for {{ meta.total }} jobs
        </span>
      </div>
      <div class="statistic-name col-1 p-0" v-for="statistic in statisticNames" :key="statistic">
        {{ statistic }}
      </div>
    </div>
    <div class="d-flex">
      <div class="col-2 p-0 d-flex justify-content-end category-value">
        <div class="col-7">
          <span />
        </div>
        <div class="col-5 text-left">
          Totals
        </div>
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.time }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.cash_payment }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.total_credit }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.total_price }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.deposit }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.carrier_total }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.cluster_total }}
      </div>
      <div class="category-value col-1 p-0">
        {{ sums.balance }}
      </div>
      <div class="category-value col-1 p-0" />
      <div class="category-value col-1 p-0">
        {{ sums.card_tips }}
      </div>
    </div>
    <div class="d-flex mb-1">
      <div class="col-2 p-0 d-flex justify-content-end category-value">
        <div class="col-7">
          <span />
        </div>
        <div class="col-5 text-left">
          Averages
        </div>
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.time }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.cash_payment }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.total_credit }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.total_price }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.deposit }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.carrier_total }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.cluster_total }}
      </div>
      <div class="avg-value col-1 p-0">
        {{ averages.balance }}
      </div>
      <div class="avg-value col-1 p-0" />
      <div class="avg-value col-1 p-0">
        {{ averages.card_tips }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    meta: {
      type: Object,
      default: () => {},
    },
    sums: {
      type: Object,
      default: () => {},
    },
    averages: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    statisticNames: [
      'Time',
      'Cash',
      'Credit',
      'Grand Total',
      'Deposit',
      'Company profit',
      'Cluster Profit',
      'Balance due',
      'Fee',
      'Tips',
    ],
  }),
};
</script>
<style lang="scss" scoped>
.totals-statistics {
  display: flex;
  background: #3f4247;
  box-shadow: 0 2px 0 rgba(33, 37, 41, 0.0263604);
  border-radius: 2px;
  height: 92px;
  justify-content: space-between;
}
.statistics {
  padding-right: 21px;
}
.fee {
  padding-right: 20px;
}
.statistics-heading {
  padding: 12px 0 0 12px;
  color: white;
  font-weight: 500;
  font-size: 12px;
}
.statistic-name {
  color: white;
  font-weight: 500;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.statistic-wrap {
  max-height: 30px;
}
.category-name {
  color: #ffffff;
  font-weight: 500;
  font-size: 12px;
  padding-top: 6px;
}
.category-value {
  color: white;
  font-weight: 500;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.avg-value {
  color: white;
  font-weight: 500;
  font-size: 10px;
  display: flex;
  align-items: center;
}
.spacing {
  margin-top: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/TotalsStatistics.vue